import sys_employee from './employee/router'
import sys_app from './app/router'

export default [{
    path: 'system',
    name: 'system',
    component: r => require.ensure([], () => r(require('./index.vue')), 'system'),
    children: [
        sys_employee,
        sys_app,
    ]
}]
